'use strict';


angular.module('app').config(['$routeProvider',
  function ($routeProvider) {
    var __timestamp__ = '';

    function loadLeaflet($http) {
      if (window.L) {
        return true;
      }
      return $http.get('/scripts/leaflet.js').then(function (res) {
        $http.get('/scripts/leaflet-cluster.js').then(function (r) {
          var func = new Function(r.data);
          func();
        });
        $http.get('/scripts/leaflet-geoip.js').then(function (r) {
          var f = new Function(r.data);
          f();
        });

        var f = new Function(res.data);
        f();
      });
    }

    var routes = [{
      route: window.createUrl('homepage'),
      routeName: 'homepage',
      params: {
        templateUrl: 'templates/_homepage.html' + __timestamp__,
      },
    },
    {
      route: window.createUrl('search_la'),
      routeName: 'search_la',
      params: {
        templateUrl: 'templates/_search_la.html' + __timestamp__,
        controller: 'SearchLaCtrl as search',
        reloadOnSearch: false,
        resolve: {
          locationInfo: ['$route', 'SearchLiveaboard', 'check404', '$rootScope', function ($route, SearchLiveaboard, check404, $rootScope) {
            return SearchLiveaboard.getLocationData($route.current.params.slug).then(function (data) {
              if (data.model === 'Liveaboard Fleet') {
                $rootScope.code404 = true;
                $rootScope.notFound = true;

                return false;
              }
              return data;
            }, function (err) {
              if (err.status == '404') {
                return check404.checkUrlStatus();
              }
            });
          }],
        },
      },
    },
    {
      route: window.createUrl('fleets'),
      routeName: 'fleets',
      params: {
        templateUrl: 'templates/_search_la.html' + __timestamp__,
        controller: 'SearchLaCtrl as search',
        reloadOnSearch: false,
        resolve: {
          locationInfo: ['$route', 'SearchLiveaboard', 'check404', '$rootScope', function ($route, SearchLiveaboard, check404, $rootScope) {
            return SearchLiveaboard.getLocationData($route.current.params.slug).then(function (data) {
              if (data.model !== 'Liveaboard Fleet') {
                $rootScope.code404 = true;
                $rootScope.notFound = true;

                return false;
              }
              return data;
            }, function (err) {
              if (err.status == '404') {
                return check404.checkUrlStatus();
              }
            });
          }],
        },
      },
    },
    {
      route: window.createUrl('search_dr'),
      routeName: 'search_dr',
      params: {
        templateUrl: 'templates/_search_dr.html' + __timestamp__,
        controller: 'SearchDrCtrl as search',
        reloadOnSearch: false,
        resolve: {
          locationInfo: ['$route', 'SearchLiveaboard', 'check404', function ($route, SearchLiveaboard, check404) {
            return SearchLiveaboard.getLocationData($route.current.params.slug).then(function (data) {
              console.log(data);
              return data;
            }, function (err) {
              if (err.status == '404') {
                return check404.checkUrlStatus();
              }
            });
          }],
          locationCoordinates: ['$route', 'Search', function ($route, Search) {
            if ($route.current.params.slug === 'all') {
              return [{
                lat: '85',
                lng: '-180',
              },
              {
                lat: '-85',
                lng: '180',
              }
              ];
            }

            return Search.getCoords($route.current.params.slug).then(function (data) {
              return data;
            });
          }],
          loadLeaflet: ['$http', function ($http) {
            return loadLeaflet($http);
          }],
        },
      },
    }, {
      route: window.createUrl('checkout_la'),
      routeName: 'checkout_la',
      params: {
        templateUrl: 'templates/_checkout_liveaboards.html' + __timestamp__,
        controller: 'CheckoutLA as ctrl',
        reloadOnSearch: false,
        resolve: {
          currentDO: ['DiveOperator', '$route', 'utils', '$rootScope', '$location', 'check404', 'gettextCatalog', function (DiveOperator, $route, utils, $rootScope, $location, check404, gettextCatalog) {
            $rootScope.loader = true;
            $rootScope.code301 = false;
            $rootScope.redirectedTo = false;

            return DiveOperator.search($route.current.params.location, $route.current.params.slug, {
              kind: 10,
            })
              .then(function (data) {
                if (data.status === 301) {
                  var path = '/liveaboard/' + data.data.country + '/' + $route.current.params.slug + '/',
                    domain = $location.$$protocol + '://' + $location.$$host;

                  $rootScope.code301 = true;

                  $rootScope.redirectedTo = domain + path;
                  $location.path(path);

                  return false;
                }

                if (data.status === 404) {
                  return check404.checkUrlStatus();
                }

                if (data.itinerariesLength) {
                  var obj = [];
                  _.each(data.itinerariesLength, function (val) {
                    obj.push({
                      id: val,
                      title: gettextCatalog.getPlural(val, '{{ count }} night', '{{ count }} nights', {
                        count: val,
                      }),
                    });
                  });

                  data.itinerariesLength = obj;
                }

                $rootScope.loader = false;
                return data;
              });
          }],
        },
      },
    }, {
      route: window.createUrl('checkout_dr'),
      routeName: 'checkout_dr',
      params: {
        templateUrl: 'templates/_checkout_dr.html' + __timestamp__,
        controller: 'CheckoutDR as ctrl',
        reloadOnSearch: false,
        resolve: {
          currentDO: ['checkoutDrService', '$route', 'GTM', 'check404', 'SeoService', 'gettextCatalog', function (checkoutDrService, $route, GTM, check404, SeoService, gettextCatalog) {
            return checkoutDrService.getShopInfo($route.current.params.slug).then(function (data) {
              data.title = data.shopComplexTitle;

              SeoService.generateMetaTags(gettextCatalog.getString('Book the Dive Resort {{ shopTitle }} | PADI Travel', { shopTitle: data.title }));

              GTM.variables({
                business_id: data.id,
                business_slug: $route.current.params.slug,
                business_area_id: data.businessAreaId,
                business_area_name: data.businessAreaName,
                business_country_id: data.businessCountryId,
                business_country_name: data.businessCountryName,
                business_country_slug: data.businessCountrySlug,
                business_last_edit_at: data.businessLastEditAt,
                business_type: data.businessType,
                destination_id: data.businessCountryId,
                destination_name: data.businessCountryName,
                destination_slug: data.businessCountrySlug,
              });

              return data;
            }).catch(function (error) {
              if (error.status === 404) {
                return check404.checkUrlStatus();
              }
            });
          }],
        },
      },
    },
    {
      route: window.createUrl('login'),
      routeName: 'login',
      params: {
        templateUrl: 'templates/_registration.html' + __timestamp__,
        controller: 'RegCtrl as reg',
        data: {
          authorization: false,
        },
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Create a free account | PADI Travel'), gettextCatalog.getString('Create a free account at PADI Travel, it’s fast, convenient and private. When you connect with Facebook all it takes is just a few seconds.'));
          }],
        },
      },
    },
    {
      route: window.createUrl('reset_password'),
      routeName: 'reset_password',
      params: {
        templateUrl: 'templates/_reset-password.html' + __timestamp__,
        controller: 'RegCtrl as reg',
        data: {
          authorization: false,
        },
      },
    },
    {
      route: window.createUrl('wizard'),
      routeName: 'wizard',
      params: {
        templateUrl: 'templates/_wizard.html' + __timestamp__,
        controller: 'WizardCtrl as wizard',
        reloadOnSearch: false,
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Virtual travel agent | PADI Travel'), gettextCatalog.getString("Choose what you'd like to see and when you'd like to go (how warm the water should be), and we'll show you the best dive destinations for your holiday."));
          }],
        },
      },
    },
    {
      route: window.createUrl('wishlist'),
      routeName: 'wishlist',
      params: {
        templateUrl: 'templates/_wishlist.html' + __timestamp__,
        controller: 'WishListCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Wishlist | PADI Travel'));
          }],
          typeURL: function () {
            return 'wishlist';
          },
        },
        data: {
          authorization: true,
        },
      },
    },
    {
      route: window.createUrl('itinerary'),
      routeName: 'itinerary',
      params: {
        templateUrl: 'templates/_itinerary.html' + __timestamp__,
        controller: 'ItineraryCtrl as ctrl',
        reloadOnSearch: false,
        resolve: {
          item: ['Request', '$route', '$rootScope', '$location', 'SeoService', 'gettextCatalog', 'check404', 'utils', function (Request, $route, $rootScope, $location, SeoService, gettextCatalog, check404, utils) {
            $rootScope.loader = true;
            $rootScope.code301 = false;
            $rootScope.redirectedTo = false;

            utils.setNoIndex(false, true);

            return Request.get('shop/' + $route.current.params.location + '/' + $route.current.params.slug + '/itineraries/' + $route.current.params.itinerarySlug + '/')
              .then(function (res) {
                $rootScope.loader = false;

                var title = res.data.title + ' | ' + res.data.shopTitle + ' | ' + gettextCatalog.getString('PADI Travel'),
                  description = gettextCatalog.getString('Learn more about the {{ countryTitle }} itinerary of the {{ shopTitle }} liveaboard. Day-to-day description, what to expect, what will you see and other important info.', {
                    countryTitle: res.data.title,
                    shopTitle: res.data.shopTitle,
                  });

                SeoService.generateMetaTags(title, description);


                return res;
              }, function (err) {
                if (err.status == '404') {
                  return check404.checkUrlStatus();
                }
                if (err.status === 301) {
                  var path = '/liveaboard/' + err.data.country + '/' + $route.current.params.slug + '/' + $route.current.params.itinerarySlug + '/',
                    domain = $location.$$protocol + '://' + $location.$$host;
                  $rootScope.code301 = true;
                  $rootScope.redirectedTo = domain + path;
                  $location.path(path);

                  return false;
                }
              });
          }],
          liveaboard: ['DiveOperator', '$route', 'utils', '$rootScope', function (DiveOperator, $route, utils, $rootScope) {
            return DiveOperator.search($route.current.params.location, $route.current.params.slug, {
              kind: utils.shopKind('Liveaboard'),
            })
              .then(function (data) {
                $rootScope.itineraryLocationTranslations = data.allLanguageSlugs;
                return data;
              });
          }],
        },
      },
    },
    {
      route: window.createUrl('bookings'),
      routeName: 'bookings',
      params: {
        templateUrl: 'templates/_booking-list.html' + __timestamp__,
        controller: 'BookingsListCtrl as ctrl',
        reloadOnSearch: false,
        resolve: {
          seo: ['SeoService', 'gettextCatalog' , function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('My bookings | PADI Travel'));
          }],
          typeURL: function () {
            return 'bookings';
          },
        },
        data: {
          authorization: true,
        },
      },
    },
    {
      route: window.createUrl('aff_bookings'),
      routeName: 'aff_bookings',
      params: {
        templateUrl: 'templates/_booking-list.html' + __timestamp__,
        controller: 'BookingsListCtrl as ctrl',
        reloadOnSearch: false,
        resolve: {
          seo: ['SeoService', 'gettextCatalog' , function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('My affiliate bookings | PADI Travel'));
          }],
          typeURL: function () {
            return 'aff_bookings';
          },
        },
        data: {
          authorization: true,
        },
      },
    },
    {
      route: window.createUrl('booking_info'),
      routeName: 'booking_info',
      params: {
        templateUrl: 'templates/_my-bookings.html' + __timestamp__,
        controller: 'MyBookings as ctrl',
        reloadOnSearch: false,
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Booking info | PADI Travel'));
          }],
          typeURL: function () {
            return 'booking_info';
          },
          list: function () {
            return {};
          },
        },
      },
    },
    {
      route: window.createUrl('coupons'),
      routeName: 'coupons',
      params: {
        templateUrl: 'templates/_coupons.html' + __timestamp__,
        controller: 'CouponCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Payment methods & discount coupons | PADI Travel'));
          }],
          typeURL: function () {
            return 'payment-and-coupons';
          },
        },
        data: {
          authorization: true,
        },
      },
    },
    {
      route: window.createUrl('settings'),
      routeName: 'settings',
      params: {
        templateUrl: 'templates/_account-settings.html' + __timestamp__,
        controller: 'AccountCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Dive destination wizard | PADI Travel'), gettextCatalog.getString("Choose what you'd like to see and when you'd like to go (how warm the water should be), and we'll show you the best dive destinations for your holiday."));
          }],
          typeURL: function () {
            return 'settings';
          },
        },
        data: {
          authorization: true,
        },
      },
    }, {
      route: window.createUrl('profile'),
      routeName: 'profile',
      params: {
        templateUrl: 'templates/_profile.html' + __timestamp__,
        controller: 'AccountCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Dive destination wizard | PADI Travel'), gettextCatalog.getString("Choose what you'd like to see and when you'd like to go (how warm the water should be), and we'll show you the best dive destinations for your holiday."));
          }],
          typeURL: function () {
            return 'profile';
          },
        },
        data: {
          authorization: true,
        },
      },
    }, {
      route: window.createUrl('preferences'),
      routeName: 'preferences',
      params: {
        templateUrl: 'templates/_preferences.html' + __timestamp__,
        controller: 'AccountCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Dive destination wizard | PADI Travel', "Choose what you'd like to see and when you'd like to go (how warm the water should be), and we'll show you the best dive destinations for your holiday.");
          }],
          typeURL: function () {
            return 'preferences';
          },
        },
        data: {
          authorization: true,
        },
      },
    }, {
      route: window.createUrl('recently_viewed'),
      routeName: 'recently_viewed',
      params: {
        templateUrl: 'templates/_recently_viewed.html' + __timestamp__,
        controller: 'RecentlyViewedCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Recently viewed | PADI Travel'));
          }],
          typeURL: function () {
            return 'recently-viewed';
          },
        },
        data: {
          authorization: true,
        },
      },
    }, {
      route: window.createUrl('register_activate'),
      routeName: 'register_activate',
      params: {
        templateUrl: 'templates/_registration-activation.html' + __timestamp__,
        controller: 'AccActivationCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('You need to accept our Terms & Conditions | PADI Travel'));
          }],
        },
      },
    }, {
      route: window.createUrl('register_completed'),
      routeName: 'register_completed',
      params: {
        templateUrl: 'templates/_registration-completed.html' + __timestamp__,
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Registration Completed | PADI Travel'));
          }],
        },
      },
    }, {

      route: window.createUrl('account_activation'),
      routeName: 'account_activation',
      params: {
        resolve: {
          activate: ['Auth', '$route', '$location', '$rootScope', 'utils', 'gettextCatalog', function (Auth, $route, $location, $rootScope, utils, gettextCatalog) {
            Auth.activateAccount($route.current.params.key).then(function (data) {
              $location.path(utils.createURL('homepage'));

              $rootScope.showNotify(gettextCatalog.getString('Your account was activated successfully'));
            }, function (error) {
              $location.path(utils.createURL('homepage'));

              $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
            });
          }],
        },
      },
    }, {
      route: window.createUrl('la_deals'),
      routeName: 'la_deals',
      params: {
        templateUrl: 'templates/_special-deals.html' + __timestamp__,
        controller: 'SpecialDealCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Special Deals on Liveaboards, Dive Resorts and Dive Packages | PADI Travel'), gettextCatalog.getString("Looking for great deals on Liveaboard trips, Dive Resorts or simply deals on dive packages? This is the place where you'll find them all!"));
          }],
          type: function () {
            return 'la_deals';
          },
          regionList: ['Request', function (Request) {
            return Request.get('places/regions/').then(function (res) {
              return res.data;
            });
          }],
        },
        reloadOnSearch: false,
      },
    }, {
      route: window.createUrl('dr_deals'),
      routeName: 'dr_deals',
      params: {
        templateUrl: 'templates/_special-deals.html' + __timestamp__,
        controller: 'SpecialDealCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Special Deals on Liveaboards, Dive Resorts and Dive Packages | PADI Travel'), gettextCatalog.getString("Looking for great deals on Liveaboard trips, Dive Resorts or simply deals on dive packages? This is the place where you'll find them all!"));
          }],
          type: function () {
            return 'dr_deals';
          },
          regionList: ['Request', function (Request) {
            return Request.get('places/regions/').then(function (res) {
              return res.data;
            });
          }],
        },
        reloadOnSearch: false,
      },
    }, {
      route: window.createUrl('group_bookings'),
      routeName: 'group_bookings',
      params: {
        templateUrl: 'templates/_group-bookings.html' + __timestamp__,
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Group Bookings & Dive Charters | PADI Travel'), gettextCatalog.getString('Organise amazing dive vacations and private charters. ✓ Free Spots ✓ Group Discounts ✓ Free Dive Insurance ✓ Concierge Service'));
          }],
        },
      },
    }, {
      route: window.createUrl('change_card'),
      routeName: 'change_card',
      params: {
        templateUrl: 'templates/_card-change.html' + __timestamp__,
        controller: 'ChangeCreditCardCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Credit card change | PADI Travel'));
          }],
        },
      },
    }, {
      route: window.createUrl('confirm_booking'),
      routeName: 'confirm_booking',
      params: {
        templateUrl: 'templates/_confirm-booking.html' + __timestamp__,
        controller: 'ChangeCreditCardCtrl as ctrl',
        resolve: {
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Confirm booking | PADI Travel'));
          }],
        },
      },
    }];

    // _.each(LANGUAGES, function(val) {
    _.each(routes, function (v) {
      if (!v.params.resolve) {
        v.params.resolve = {};
      }
      v.params.resolve.routeName = ['$rootScope', function ($rootScope) {
        $rootScope.routeName = v.routeName;
        return v.routeName;
      }];
      v.params.resolve.lang = function () {
        return window.lang;
      };

      $routeProvider.when(v.route, v.params);
    });
    // })

    $routeProvider
      .when(window.createUrl('la_page'), {
        templateUrl: 'templates/_liveaboard.html' + __timestamp__,
      })
      .when(window.createUrl('dr_page'), {
        templateUrl: 'templates/_dive-resort.html' + __timestamp__,
      })
      .when(window.createUrl('destination'), {
        templateUrl: 'templates/_destination.html' + __timestamp__,
      })
      .when(window.createUrl('destinations'), {
        templateUrl: 'templates/_destination_map.html' + __timestamp__,
      })
      .when(window.createUrl('liveaboard_diving_location'), {
        templateUrl: 'templates/_liveaboard-diving.html' + __timestamp__,
      })
    // .when('/about/', {
    //     templateUrl: 'templates/_about-us.html',
    //     resolve: {
    //         seo: function (SeoService, gettextCatalog) {
    //             SeoService.generateMetaTags('About | PADI Travel', "Learn more about who's behind PADI Travel, what makes us unique and how we are disrupting the dive industry.");
    //         }
    //     }
    // })
      .when(window.createUrl('why_book_with_us'), {
        templateUrl: 'templates/_why-book-with-us.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Why book with us | PADI Travel', 'Best selection, best prices and 100% safe. Read why booking your next scuba holiday with PADI Travel is the smartest choice for you.');
          },
        },
      })
      .when(window.createUrl('faq'), {
        templateUrl: 'templates/_faq.html' + __timestamp__,
        controller: 'FaqCtrl as faq',
        reloadOnSearch: false,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Frequently asked questions | PADI Travel', 'The most frequently asked question about PADI Travel and the holidays offered on the website.');
          },
        },
      })
      .when(window.createUrl('terms'), {
        templateUrl: 'templates/_terms.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Terms and conditions | PADI Travel', '');
          },
        },
      })
      .when(window.createUrl('terms_dc'), {
        templateUrl: 'templates/_terms-dc.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Terms and conditions | PADI Travel', '');
          },
        },
      })
      .when(window.createUrl('imprint'), {
        templateUrl: 'templates/_imprint.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Imprint | PADI Travel', '');
          },
        },
      })
      .when(window.createUrl('privacy'), {
        templateUrl: 'templates/_privacy.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Privacy policy | PADI Travel', '');
          },
        },
      })
      .when(window.createUrl('best_price_guarantee'), {
        templateUrl: 'templates/_best-price.html' + __timestamp__,
        resolve: {
          seo: function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags('Best price guarantee | PADI Travel', 'Learn how our best price guarantee policy allows you to be sure to pay the lowest possible price for your next scuba holiday.');
          },
        },
      })
      .when('/widget/:id', {
        templateUrl: 'templates/widget.html' + __timestamp__,
        controller: 'WidgetCtrl as widget',
        resolve: {},
      })
      .when(window.createUrl('liveaboard_diving'), {
        templateUrl: 'templates/_la_diving.html' + __timestamp__,
      })
      .when(window.createUrl('last_minute_deals'), {
        templateUrl: 'templates/_homepage.html' + __timestamp__,
      })
      .otherwise({
        templateUrl: 'templates/404.html',
        resolve: {
          pageStatus: function (check404) {
            'ngInject';

            return check404.checkUrlStatus();
          },
          error404: function () {
            return true;
          },
          seo: ['SeoService', 'gettextCatalog', function (SeoService, gettextCatalog) {
            SeoService.generateMetaTags(gettextCatalog.getString('Page not found | PADI Travel'), '');
          }],
        },
      });
  }
]);
